import React from "react"
import moment from "moment"
import { Input, Label } from "reactstrap"

const AlternativeConfigFieldViewOnly = React.memo(function configField({
  label,
  prop,
  value,
  options,
  fieldConfigItems,
  type,
}) {
  const fieldConfig = fieldConfigItems.find(
    x => x.fieldName.toLowerCase() == prop.toLowerCase()
  )
  let classes = "form-control form-select select2 mb-xxl-0 "

  classes +=
    fieldConfig == undefined || fieldConfig.fieldStatus == "show"
      ? ""
      : fieldConfig.fieldStatus == "read only"
      ? "always-disabled"
      : "always-hidden"

  const isHidden =
    fieldConfig !== undefined && fieldConfig.fieldStatus == "hide"

  if (isHidden) return null
  if (type == undefined || type == "select") {
    return (
      <div className="mb-3">
        <Label className="form-label">{label}</Label>
        <p>{options?.find(x => x.listItemID == value)?.listItemName}</p>
      </div>
    )
  } else if (type == "date") {
    return (
      <div className="mb-3">
        <Label className="form-label">{label}</Label>
        <p>
          {new Date(value) > new Date(1900, 1, 1, 0, 0, 0, 0)
            ? moment(value).format("MM/DD/YYYY")
            : ""}
        </p>
      </div>
    )
  } else if (type == "datetime") {
    return (
      <div className="mb-3">
        <Label className="form-label">{label}</Label>
        <p>
          {new Date(value) > new Date(1900, 1, 1, 0, 0, 0, 0)
            ? moment(value).format("YYYY-MM-DD HH:mm")
            : ""}
        </p>
      </div>
    )
  } else if (type == "text") {
    return (
      <div className="mb-3">
        <Label className="form-label">{label}</Label>
        <p>{value}</p>
      </div>
    )
  } else if (type == "int") {
    return (
      <div className="mb-3">
        <Label className="form-label">{label}</Label>
        <p>{isNaN(value) ? value : parseInt(value)}</p>
      </div>
    )
  } else if (type == "checkbox") {
    return (
      <div className="mb-3">
        <Input
          type="checkbox"
          className="form-check-input"
          checked={value}
          disabled={true}
        />
        <Label className="form-check-label">{label}</Label>
      </div>
    )
  } else {
    return null
  }
})

export default AlternativeConfigFieldViewOnly